module.exports = __webpack_public_path__ + "img/375.f0cc87b9.jpg";